module.exports=[
  {
    "nom": "Centre Culturel",
    "adresse": "1 rue Amédée Savidan",
    "codepostal": 72120,
    "ville": "SAINT CALAIS",
    "mail": "culturel.saintcalais@orange.fr",
    "www": "http://www.saint-calais.fr",
    "telephone": "0243356303",
    "type": "Commune",
    "convetionnement": "",
    "licence": "",
    "reseaux": "PÉCANS",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 15,
    "diffusion_jp": 12,
    "diffusion_0_3ans": 2,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 4,
    "diffusion_12ans": 4,
    "diffusion_places_jp": 1500,
    "diffusion_departement": "72",
    "diffusion_epci": "200072692",
    "diffusion_commune": "72269",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": "72",
    "actionculturelle_epci": "200072692",
    "actionculturelle_commune": "72269",
    "coords": [
      47.9211882,
      0.7435439
    ]
  },
  {
    "nom": "ADAJ Le Jardin de Verre",
    "adresse": "13 bd Gustave Richard",
    "codepostal": 49300,
    "ville": "Cholet",
    "mail": "francois.gabory@jardindeverre.fr",
    "www": "http://www.jardindeverre.fr/",
    "telephone": "0241651358",
    "type": "Association",
    "convetionnement": "",
    "licence": "1-1013478 2-1013479 3-1013480",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Non",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 0,
    "diffusion_jp": 0,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 0,
    "diffusion_6_12ans": 0,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 0,
    "diffusion_departement": "",
    "diffusion_epci": "",
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": "49",
    "actionculturelle_epci": "200071678",
    "actionculturelle_commune": "",
    "coords": [
      47.0626803,
      -0.8809777
    ]
  },
  {
    "nom": "Théâtre du Champ de Bataille",
    "adresse": "10 rue du Champ de Bataille",
    "codepostal": 49100,
    "ville": "Angers",
    "mail": "contact@champdebataille.net",
    "www": "http://champdebataille.net",
    "telephone": "0241720094",
    "type": "Théâtre",
    "convetionnement": "",
    "licence": "1-1052037 2–1052038 3-1052039",
    "reseaux": "",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 2,
    "aidecreation_coprod": 2,
    "aidecreation_residence": 3,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 18,
    "diffusion_jp": 7,
    "diffusion_0_3ans": 2,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 3,
    "diffusion_12ans": 4,
    "diffusion_places_jp": 5760,
    "diffusion_departement": "49",
    "diffusion_epci": "244900015",
    "diffusion_commune": "49007",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": "49",
    "actionculturelle_epci": "244900015",
    "actionculturelle_commune": "",
    "coords": [
      47.4815035,
      -0.5673384
    ]
  },
  {
    "nom": "Théâtre Philippe Noiret",
    "adresse": "PLACE DES FONTAINES • DOUÉ-LA-FONTAINE",
    "codepostal": 49700,
    "ville": "DOUÉ-EN-ANJOU",
    "mail": "d.touquet@doue-en-anjou.fr",
    "www": "http://www.doue-en-anjou.fr",
    "telephone": "0241500977",
    "type": "Théâtre municipal",
    "convetionnement": "",
    "licence": "1-1101319",
    "reseaux": "PJP49",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 1,
    "aidecreation_coprod": 1,
    "aidecreation_residence": 1,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 22,
    "diffusion_jp": 8,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 3,
    "diffusion_12ans": 2,
    "diffusion_places_jp": 3300,
    "diffusion_departement": "49",
    "diffusion_epci": "200071876",
    "diffusion_commune": "49125",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": "49",
    "actionculturelle_epci": "200071876",
    "actionculturelle_commune": "49125",
    "coords": [
      47.1954695,
      -0.276190493017237
    ]
  },
  {
    "nom": "Espace culturel Léopold Sédar Senghor",
    "adresse": "4, rue des tilleuls",
    "codepostal": 49122,
    "ville": "LE MAY-SUR-EVRE",
    "mail": "",
    "www": "http://www.espacesenghor.fr",
    "telephone": "0241716848",
    "type": "Théâtre municipal",
    "convetionnement": "",
    "licence": "1-1043979",
    "reseaux": "PJP49",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 2,
    "aidecreation_coprod": 1,
    "aidecreation_residence": 2,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Festival L'arbre à pompons",
    "diffusion_total": 18,
    "diffusion_jp": 8,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 4,
    "diffusion_12ans": 1,
    "diffusion_places_jp": 2140,
    "diffusion_departement": "49",
    "diffusion_epci": "200071678",
    "diffusion_commune": "49193",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": "49",
    "actionculturelle_epci": "200071678",
    "actionculturelle_commune": "49193",
    "coords": [
      47.1363776,
      -0.8928297
    ]
  },
  {
    "nom": "Le Cargo",
    "adresse": "Place du Port",
    "codepostal": 49500,
    "ville": "Segré-en-anjou-bleu",
    "mail": "culture@segreenanjoubleu.fr",
    "www": "https://www.segreenanjoubleu.fr/vivre-ici/culture/le-cargo/",
    "telephone": "0241923189",
    "type": "Théâtre municipal",
    "convetionnement": "",
    "licence": "1-1036466 2-1036416 3-1036417",
    "reseaux": "PJP49",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 1,
    "aidecreation_coprod": 1,
    "aidecreation_residence": 1,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 18,
    "diffusion_jp": 4,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 1,
    "diffusion_6_12ans": 1,
    "diffusion_12ans": 1,
    "diffusion_places_jp": 1650,
    "diffusion_departement": "49",
    "diffusion_epci": "244900809",
    "diffusion_commune": "49331",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": "49",
    "actionculturelle_epci": "244900809",
    "actionculturelle_commune": "49331",
    "coords": [
      47.6856229,
      -0.868027518913304
    ]
  },
  {
    "nom": "Commune de Loire-Authion",
    "adresse": "24-26 Levée Jeanne de Laval - Saint Mathurin sur Loire",
    "codepostal": 49250,
    "ville": "Loire-Authion",
    "mail": "contact@loire-authion.fr",
    "www": "http://www.loire-authion.fr",
    "telephone": "0241573608",
    "type": "Commune",
    "convetionnement": "",
    "licence": "3-1103392",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 24,
    "diffusion_jp": 9,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 7,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 1100,
    "diffusion_departement": "49",
    "diffusion_epci": "244900015",
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": "49",
    "actionculturelle_epci": "244900015",
    "actionculturelle_commune": "",
    "coords": [
        47.408833, -0.318601
    ]
  },
  {
    "nom": "ONPL - Orchestre National des Pays de la Loire",
    "adresse": "Maison des Arts-Esplanade H. Dutilleux - BP 15246",
    "codepostal": 49052,
    "ville": "ANGERS",
    "mail": "",
    "www": "http://www.onpl.fr",
    "telephone": "0241246842",
    "type": "SYNDICAT MIXTE ONPL",
    "convetionnement": "",
    "licence": "2-1094261 3-1094262",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 106,
    "diffusion_jp": 14,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 0,
    "diffusion_6_12ans": 7,
    "diffusion_12ans": 7,
    "diffusion_places_jp": 5800,
    "diffusion_departement": "44 49",
    "diffusion_epci": "244400404 200060010 200071678 200071876 244900015",
    "diffusion_commune": "44109 49092 49193 49125 49328 49007",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": "44 49",
    "actionculturelle_epci": "200067635 200067866 200072726 244400404 244400438 244400503 244400537 244400552 200060010 200071678 200071876 244900015",
    "actionculturelle_commune": "44036 44026 44047 44114 44162 44003 49023 49092 49218 49244 49301 49099 49192 49193 49355 49125 49149 49180 49215 49219 49261 49328 49007 49200",
    "coords": [
        47.452874, -0.510892
    ]
  },
  {
    "nom": "Département Maine-et-Loire",
    "adresse": "CS 94104",
    "codepostal": 49941,
    "ville": "Angers",
    "mail": "",
    "www": "http://www.maine-et-loire.fr",
    "telephone": "0241256276",
    "type": "Département",
    "convetionnement": "",
    "licence": "",
    "reseaux": "",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 8,
    "aidecreation_residence": 0,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 0,
    "diffusion_jp": 0,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 0,
    "diffusion_6_12ans": 0,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 0,
    "diffusion_departement": "",
    "diffusion_epci": "",
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Non",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": "",
    "actionculturelle_epci": "",
    "actionculturelle_commune": "",
    "coords": [
        47.470497, -0.551607
    ]
  },
  {
    "nom": "Direction Culture de Saint-Nazaire",
    "adresse": "Place François Blancho",
    "codepostal": 44600,
    "ville": "Saint-Nazaire",
    "mail": "",
    "www": "http://www.saintnazaire.fr/",
    "telephone": "0240004177",
    "type": "Ville",
    "convetionnement": "",
    "licence": "",
    "reseaux": "Collectif des médiateurs jeune public des Pays de la Loire",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Non",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 0,
    "diffusion_jp": 0,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 0,
    "diffusion_6_12ans": 0,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 0,
    "diffusion_departement": "",
    "diffusion_epci": "",
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": "44",
    "actionculturelle_epci": "244400644",
    "actionculturelle_commune": "44184",
    "coords": [
      47.2738604,
      -2.21376835
    ]
  },
  {
    "nom": "Centre Chorégraphique National de Nantes",
    "adresse": "23 rue noire",
    "codepostal": 44000,
    "ville": "NANTES",
    "mail": "p.tessiertalon@ccnn.fr",
    "www": "http://www.ccnnantes.fr",
    "telephone": "0240933097",
    "type": "Centre Chorégraphique National",
    "convetionnement": "",
    "licence": "1-1087797 2-1087798 3-1087799",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 9,
    "diffusion_jp": 5,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 3,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 1630,
    "diffusion_departement": "44",
    "diffusion_epci": "244400404",
    "diffusion_commune": "44109",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": "44",
    "actionculturelle_epci": "244400404",
    "actionculturelle_commune": "44109",
    "coords": [
      47.2265068,
      -1.5621005
    ]
  },
  {
    "nom": "Association Les Escales",
    "adresse": "23 rue d'Anjou",
    "codepostal": 44600,
    "ville": "SAINT NAZAIRE",
    "mail": "cmathieu@les-escales.com",
    "www": "http://www.levip-saintnazaire.com/",
    "telephone": "0251100000",
    "type": "SMAC/FESTIVAL",
    "convetionnement": "",
    "licence": "1-1098761 2-1098762 3-1098763",
    "reseaux": "",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 1,
    "aidecreation_residence": 0,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 40,
    "diffusion_jp": 4,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 1,
    "diffusion_6_12ans": 3,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 700,
    "diffusion_departement": "44",
    "diffusion_epci": "244400644",
    "diffusion_commune": "44013 44184",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": "44",
    "actionculturelle_epci": "244400644",
    "actionculturelle_commune": "44184",
    "coords": [
      47.28284,
      -2.2093571
    ]
  },
  {
    "nom": "Un Deux Un Deux",
    "adresse": "11 ROUTE DE SAINTE-FLAIVE, BOURGCHOLET",
    "codepostal": 85150,
    "ville": "LANDERONDE",
    "mail": "marion@undeuxundeux.com",
    "www": "http://www.undeuxundeux.com",
    "telephone": "0630485506",
    "type": "Association",
    "convetionnement": "",
    "licence": "2-1098780 3-1098781",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Non",
    "activite_actionculturelle": "Non",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 0,
    "diffusion_jp": 0,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 0,
    "diffusion_6_12ans": 0,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 0,
    "diffusion_departement": "",
    "diffusion_epci": "",
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Non",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": "",
    "actionculturelle_epci": "",
    "actionculturelle_commune": "",
    "coords": [
        46.658873, -1.571327
    ]
  },
  {
    "nom": "Scènes de Pays (service culture de Mauges Communauté)",
    "adresse": "Rue Robert Schuman – La Loge - Beaupréau",
    "codepostal": 49600,
    "ville": "Beaupréau-en-Mauges",
    "mail": "scenesdepays@maugescommunaute.fr",
    "www": "http://www.scenesdepays.fr",
    "telephone": "0241753834",
    "type": "Scène conventionnée",
    "convetionnement": "Art en territoire",
    "licence": "2-1108017 3-1108018",
    "reseaux": "PJP49",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 6,
    "aidecreation_coprod": 2,
    "aidecreation_residence": 2,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 51,
    "diffusion_jp": 18,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 9,
    "diffusion_6_12ans": 4,
    "diffusion_12ans": 5,
    "diffusion_places_jp": 14387,
    "diffusion_departement": "49",
    "diffusion_epci": "200060010",
    "diffusion_commune": "49023 49069 49092 49218 49244 49301",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": "49",
    "actionculturelle_epci": "200060010",
    "actionculturelle_commune": "49023 49069 49092 49218 49244 49301",
    "coords": [
        47.210055, -0.982094
    ]
  },
  {
    "nom": "Théâtre de l’Échappée",
    "adresse": "Quartier Ferrié / 30 rue Henri Géret",
    "codepostal": 53000,
    "ville": "LAVAL",
    "mail": "francoisbechu@theatrelechappee.com",
    "www": "http://www.theatrelechappee.com",
    "telephone": "0608770651",
    "type": "Association",
    "convetionnement": "",
    "licence": "2-1015785 3-1075786",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Quinzaine",
    "diffusion_total": 34,
    "diffusion_jp": 10,
    "diffusion_0_3ans": 10,
    "diffusion_3_6ans": 5,
    "diffusion_6_12ans": 2,
    "diffusion_12ans": 2,
    "diffusion_places_jp": 1450,
    "diffusion_departement": "53",
    "diffusion_epci": "245300306",
    "diffusion_commune": "53137",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": "53",
    "actionculturelle_epci": "245300330",
    "actionculturelle_commune": "53130",
    "coords": [
        48.079071, -0.784373
    ]
  },
  {
    "nom": "Mayenne Culture",
    "adresse": "84 avenue Robert Buron - CS 21429",
    "codepostal": 53014,
    "ville": "LAVAL",
    "mail": "contact@mayenneculture.fr",
    "www": "http://www.mayenneculture.fr",
    "telephone": "0243676090",
    "type": "Agence départementale",
    "convetionnement": "",
    "licence": "",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 13,
    "diffusion_jp": 2,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 0,
    "diffusion_6_12ans": 2,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 470,
    "diffusion_departement": "53",
    "diffusion_epci": "200033298 200042182 200048551 200055887 245300223 245300306 245300330 245300355 245300389 245300447",
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": "53",
    "actionculturelle_epci": "200033298 200042182 200048551 200055887 245300223 245300306 245300330 245300355 245300389 245300447",
    "actionculturelle_commune": "",
    "coords": [
        48.074488, -0.762219
    ]
  },
  {
    "nom": "Un Singe En Été",
    "adresse": "7 place Juhel",
    "codepostal": 53100,
    "ville": "Mayenne",
    "mail": "info@tribufamilia.fr",
    "www": "http://www.unsingeenete.com",
    "telephone": "0243304025",
    "type": "Festival",
    "convetionnement": "",
    "licence": "2-1110443 3-1110444",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 32,
    "diffusion_jp": 1,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 1,
    "diffusion_6_12ans": 0,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 180,
    "diffusion_departement": "53",
    "diffusion_epci": "200055887",
    "diffusion_commune": "53147",
    "actionculturelle_scolaire": "Non",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": "53",
    "actionculturelle_epci": "200055887",
    "actionculturelle_commune": "",
    "coords": [
      48.3025635,
      -0.619756111042693
    ]
  },
  {
    "nom": "Festival les Embuscades",
    "adresse": "58 place Tussenhausen BP 52",
    "codepostal": 53230,
    "ville": "Cossé le Vivien",
    "mail": "",
    "www": "http://www.lesembuscades.fr",
    "telephone": "0243917963",
    "type": "Association",
    "convetionnement": "",
    "licence": "2-1004734 3-100 4735",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Les Embuscades pour les scolaires",
    "diffusion_total": 0,
    "diffusion_jp": 3,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 0,
    "diffusion_6_12ans": 0,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 0,
    "diffusion_departement": "53",
    "diffusion_epci": "200048551",
    "diffusion_commune": "53011 53058 53075 53077 53082 53088 53102 53128 53151 53186 53250",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": "53",
    "actionculturelle_epci": "200048551",
    "actionculturelle_commune": "",
    "coords": [
        47.944931, -0.912623
    ]
  },
  {
    "nom": "MômoFestival",
    "adresse": "15 les champs roux",
    "codepostal": 72610,
    "ville": "OISSEAU LE PETIT",
    "mail": "",
    "www": "http://kikloche.free.fr/momo2018/index2018.html",
    "telephone": "0652017393",
    "type": "Association Festivals en Pays de Haute Sarthe",
    "convetionnement": "",
    "licence": "2-1048600 3-1085420",
    "reseaux": "PÉCANS",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "MômoFestival",
    "diffusion_total": 20,
    "diffusion_jp": 8,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 3,
    "diffusion_6_12ans": 4,
    "diffusion_12ans": 12,
    "diffusion_places_jp": 1600,
    "diffusion_departement": "72",
    "diffusion_epci": "200072700 200072718 246100663",
    "diffusion_commune": "72005 72138 72380 72334",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": "72",
    "actionculturelle_epci": "200072700",
    "actionculturelle_commune": "72029 72380",
    "coords": [
        48.350744, 0.090295
    ]
  },
  {
    "nom": "Les compagnons de la bertoche",
    "adresse": "217 rue de la bertinière",
    "codepostal": 72000,
    "ville": "LE MANS",
    "mail": "compagnonsdelabertoche@gmail.com",
    "www": "http://",
    "telephone": "0671703537",
    "type": "Compagnie",
    "convetionnement": "",
    "licence": "2-1073252",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Non",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 0,
    "diffusion_jp": 0,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 0,
    "diffusion_6_12ans": 0,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 0,
    "diffusion_departement": "",
    "diffusion_epci": "",
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": "72",
    "actionculturelle_epci": "247200132",
    "actionculturelle_commune": "72181",
    "coords": [
      47.9919747,
      0.215672
    ]
  },
  {
    "nom": "Centre socioculturel François Rabelais",
    "adresse": "1, place Victor Hugo",
    "codepostal": 72560,
    "ville": "Changé",
    "mail": "culture@lerabelais.org",
    "www": "http://www.lerabelais.org",
    "telephone": "0243401304",
    "type": "Centre socioculturel",
    "convetionnement": "",
    "licence": "1-145104 2-145105 3-145106",
    "reseaux": "Réseau JP Sarthe Collectif Pays du môme",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Non",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Festival Au Pays du Môme",
    "diffusion_total": 24,
    "diffusion_jp": 7,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 4,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 2910,
    "diffusion_departement": "72",
    "diffusion_epci": "247200421",
    "diffusion_commune": "72058",
    "actionculturelle_scolaire": "N/A",
    "actionculturelle_periscolaire": "N/A",
    "actionculturelle_extrascolaire": "N/A",
    "actionculturelle_departement": "",
    "actionculturelle_epci": "",
    "actionculturelle_commune": "",
    "coords": [
      47.9859227,
      0.283297
    ]
  },
  {
    "nom": "L’Excelsior",
    "adresse": "18 rue Georges Bizet",
    "codepostal": 72700,
    "ville": "ALLONNES",
    "mail": "",
    "www": "http://www.lexcelsior.fr",
    "telephone": "0243834515",
    "type": "Régie personnalisée",
    "convetionnement": "",
    "licence": "1-1019449 1-1048568 2-1019450",
    "reseaux": "Réseau JP Sarthe Collectif Pays du môme",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Non",
    "aidecreation_preachat": 5,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 1,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 0,
    "diffusion_jp": 8,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 1,
    "diffusion_6_12ans": 4,
    "diffusion_12ans": 2,
    "diffusion_places_jp": 0,
    "diffusion_departement": "72",
    "diffusion_epci": "247200132",
    "diffusion_commune": "72003",
    "actionculturelle_scolaire": "N/A",
    "actionculturelle_periscolaire": "N/A",
    "actionculturelle_extrascolaire": "N/A",
    "actionculturelle_departement": "",
    "actionculturelle_epci": "",
    "actionculturelle_commune": "",
    "coords": [
      47.9701759,
      0.1618363
    ]
  },
  {
    "nom": "Association Mouillotins Animation et culture",
    "adresse": "1 c rue de bretagne",
    "codepostal": 53540,
    "ville": "Cuillé",
    "mail": "mouillotins@gmail.com",
    "www": "http://www.mouillotins.fr",
    "telephone": "0954159408",
    "type": "Association",
    "convetionnement": "",
    "licence": "2-141752 3-141753",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Non",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Les Mouillos",
    "diffusion_total": 3,
    "diffusion_jp": 3,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 1,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 1000,
    "diffusion_departement": "53",
    "diffusion_epci": "200048551",
    "diffusion_commune": "53250 53258",
    "actionculturelle_scolaire": "N/A",
    "actionculturelle_periscolaire": "N/A",
    "actionculturelle_extrascolaire": "N/A",
    "actionculturelle_departement": "",
    "actionculturelle_epci": "",
    "actionculturelle_commune": "",
    "coords": [
      47.97037,
      -1.1233347
    ]
  },
  {
    "nom": "Pazapa",
    "adresse": "35 rue de degré",
    "codepostal": 72000,
    "ville": "LE MANS",
    "mail": "virna@cie-robinjuteau.com",
    "www": "http://www.cie-robinjuteau.com/",
    "telephone": "0666919054",
    "type": "Compagnie danse contemporaine",
    "convetionnement": "",
    "licence": "2-1043959 3-1043958",
    "reseaux": "",
    "activite_aidecreation": "N/A",
    "activite_diffusion": "N/A",
    "activite_actionculturelle": "N/A",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "N/A",
    "diffusion_festival_nom": "",
    "diffusion_total": 0,
    "diffusion_jp": 0,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 0,
    "diffusion_6_12ans": 0,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 0,
    "diffusion_departement": "",
    "diffusion_epci": "",
    "diffusion_commune": "",
    "actionculturelle_scolaire": "N/A",
    "actionculturelle_periscolaire": "N/A",
    "actionculturelle_extrascolaire": "N/A",
    "actionculturelle_departement": "",
    "actionculturelle_epci": "",
    "actionculturelle_commune": "",
    "coords": [
      48.0148721,
      0.1832314
    ]
  },
  {
    "nom": "Fuzz’Yon",
    "adresse": "10 RUE PASTEUR",
    "codepostal": 85005,
    "ville": "LA ROCHE-SUR-YON",
    "mail": "",
    "www": "http://www.fuzzyon.com",
    "telephone": "0251069770",
    "type": "Scène de musiques actuelles",
    "convetionnement": "",
    "licence": "1-1004745 2-1004746 3-1004747",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 42,
    "diffusion_jp": 5,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 1,
    "diffusion_6_12ans": 4,
    "diffusion_12ans": 1,
    "diffusion_places_jp": 1405,
    "diffusion_departement": "85",
    "diffusion_epci": "248500589",
    "diffusion_commune": "85191",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": "85",
    "actionculturelle_epci": "248500589",
    "actionculturelle_commune": "85191",
    "coords": [
      46.6719116,
      -1.4300186
    ]
  },
  {
    "nom": "La Castelorienne",
    "adresse": "92, avenue Jean Jaures -Château-du-Loir",
    "codepostal": 72500,
    "ville": "MONTVAL-SUR-LOIR",
    "mail": "",
    "www": "http://www.ville-chateauduloir.fr/",
    "telephone": "0243794797",
    "type": "Théâtre municipal",
    "convetionnement": "",
    "licence": "1-1098817 1-1098818 2-1098819 3-1098820",
    "reseaux": "Réseau JP Sarthe",
    "activite_aidecreation": "non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Malice au pays",
    "diffusion_total": 13,
    "diffusion_jp": 11,
    "diffusion_0_3ans": 2,
    "diffusion_3_6ans": 4,
    "diffusion_6_12ans": 3,
    "diffusion_12ans": 2,
    "diffusion_places_jp": 2530,
    "diffusion_departement": "",
    "diffusion_epci": "",
    "diffusion_commune": "72071",
    "actionculturelle_scolaire": "N/A",
    "actionculturelle_periscolaire": "N/A",
    "actionculturelle_extrascolaire": "N/A",
    "actionculturelle_departement": "",
    "actionculturelle_epci": "",
    "actionculturelle_commune": "",
    "coords": [
      47.6910963,
      0.4153333
    ]
  }
]
